import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/card/Card.tsx
var n = (n) => {
	let { className: r = "", shadow: i = "default", padding: a = 15, children: o, ...s } = n, c = e("bg-white", "rounded", "border", `shadow-${i}`, `padding-${a}`, r);
	return /* @__PURE__ */ t("div", {
		...s,
		className: c,
		children: o
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=Card.js.map